import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const location = useLocation()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    setIsMenuOpen(false)
  }, [location])

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 100)
    return () => clearTimeout(timer)
  }, [])

  // Navigation items data
  const navItems = [
    { path: "/", label: "Home", icon: "🏠" },
    { path: "/about", label: "About Us", icon: "👥" },
    { path: "/services", label: "Services", icon: "🦷" },
    { path: "/team", label: "Our Team", icon: "👨‍⚕️" },
    { path: "/insights", label: "Insights", icon: "📚" },
    { path: "/training", label: "Training", icon: "🎓" },
    { path: "/contact", label: "Contact", icon: "📞" }
  ]

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${isVisible ? 'visible' : ''}`}>
      <div className="nav-container">
        {/* Enhanced Logo with explicit dimensions */}
        <Link to="/" className="nav-logo">
          <div className="logo-wrapper group">
            <img 
              src='/images/logo.png'
              alt="Emmanuel DentalCare Logo" 
              className="logo-image"
              width="45"  // Explicit width
              height="45" // Explicit height
              loading="eager" // Load immediately
              onError={(e) => {
                // Fallback to text if image fails to load
                e.target.style.display = 'none';
                const fallback = e.target.nextElementSibling;
                if (fallback) {
                  fallback.style.display = 'flex';
                }
              }}
              onLoad={(e) => {
                // Image loaded successfully
                e.target.style.opacity = '1';
              }}
            />
            <div className="logo-fallback">
              <span className="logo-icon">🦷</span>
            </div>
            <div className="logo-text">
              <span className="logo-primary">Emmanuel Total</span>
              <span className="logo-secondary">DentalCare</span>
            </div>
          </div>
        </Link>
        
        {/* Enhanced Navigation Menu */}
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <div className="nav-links">
            {navItems.map((item, index) => (
              <Link 
                key={item.path}
                to={item.path} 
                className={`nav-link group ${location.pathname === item.path ? 'active' : ''}`}
              >
                <span className="nav-link-icon">
                  {item.icon}
                </span>
                <span className="nav-link-text">
                  {item.label}
                  {location.pathname === item.path && (
                    <span className="active-indicator"></span>
                  )}
                </span>
              </Link>
            ))}
            
            {/* Enhanced Appointment Link */}
            <Link 
              to="/appointment" 
              className={`nav-link appointment-link group ${location.pathname === '/appointment' ? 'active' : ''}`}
            >
              <span className="appointment-icon">📅</span>
              <span className="appointment-text">
                Appointment
              </span>
            </Link>
          </div>
        </div>

        {/* Enhanced Mobile Toggle Button */}
        <button 
          className={`nav-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
      
      {/* Enhanced Mobile Menu Background Overlay */}
      {isMenuOpen && (
        <div 
          className="nav-overlay"
          onClick={toggleMenu}
          aria-hidden="true"
        />
      )}
    </nav>
  )
}

export default Navbar